import { Injectable, inject } from '@angular/core'
import { select, Store, Action } from '@ngrx/store'
import * as TaxesSelectors from './taxes.selectors'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

@Injectable({
  providedIn: 'root',
})
export class TaxesFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(TaxesSelectors.selectTaxesLoaded))
  allTaxes$ = this.store.pipe(select(TaxesSelectors.selectAllTaxes))
  selectedTaxes$ = this.store.pipe(select(TaxesSelectors.selectEntity))
  createEditLoaded$ = this.store.pipe(select(TaxesSelectors.selectEditCreateLoaded))
  getTaxByUuid$ = (uuid: string) => this.store.pipe(select(TaxesSelectors.selectTaxByUuid(uuid)))

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
